<script setup lang="ts">
import { inject, type Ref } from 'vue'
import { useRouter } from 'vue-router'
import { useToast } from 'vue-fomantic-ui'
import { useUserStore } from '@/stores/user'
import { useRoomStore } from '@/stores/rooms'
import { useContainerStore } from '@/stores/containers'
import type { Room } from '@/models/Room'
import type { Container } from '@/models/Container'
import { ScanMode, ScanTarget } from '@/models/Scan'
import Title from '@/components/Title.vue'
import Scanner from '@/components/Scanner/Scanner.vue'
import MultipleScanHeading from '@/components/Heading/MultipleScanHeading.vue'
import RoomScanHeading from '@/components/Heading/RoomScanHeading.vue'
import ContainerScanHeading from '@/components/Heading/ContainerScanHeading.vue'

const router = useRouter()
const { toast } = useToast()

const userStore = useUserStore()
const user = userStore.authenticatedUser

const roomStore = useRoomStore()
const containerStore = useContainerStore()

const room = inject('room') as Ref<Room | null>
const container = inject('container') as Ref<Container | null>

const scannerHeight = user?.scanMode === ScanMode.Zebra ? '50dvh' : '37.5dvh'

const barcodeScanned = async (value: string) => {
  const scannedRoom = roomStore.findByCode(value)
  const scannedContainer = containerStore.findByCode(value)

  if (!scannedRoom && !scannedContainer) {
    toast({
      position: 'centered',
      message: `Le code barre scanné n'est pas celui d'un local ou d'un bac.`,
      type: 'warning',
    })
    return
  }

  room.value = scannedRoom || room.value
  container.value = scannedContainer || container.value

  router.push({ name: 'report-incident-type' })
}
</script>

<template>
  <div class="page report-incident-scan">
    <Title>Signaler un incident</Title>
    <MultipleScanHeading v-if="user?.scanMode === ScanMode.Zebra" />
    <template v-else>
      <RoomScanHeading />
      <div class="separator">ou</div>
      <ContainerScanHeading />
    </template>
    <Scanner :target="ScanTarget.Multiple" @barcode-scanned="barcodeScanned"></Scanner>
  </div>
</template>

<style scoped lang="scss">
.report-incident-scan {
  .scanner {
    height: v-bind('scannerHeight');
  }

  .separator {
    font-weight: 600;
    line-height: 1;
    text-align: center;
    text-transform: uppercase;
  }
}
</style>
